// tslint:disable: cyclomatic-complexity
import Styled, { css } from 'styled-components';

import { VALID_GLOBAL_FONT_SIZES } from '../../Typography/common';
import { cssDeclaration } from '../../Utils';

interface IStepContainerProps {
  isComplete: boolean;
  isActive: boolean;
}

export const ProgressTrackerContainer = Styled.div`
  width: 100%;
  padding: 0.75em 0;

  ${({ theme: { themeTwo }}) => {
    const { progressTracker: { desktop } } = themeTwo;

    return css`
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', desktop.backgroundColor)};
    `;
  }}
`;

export const StepHr = Styled.div`
  left: 50%;
  position: absolute;
  display: inline-block;

  ${({ theme: { themeTwo }}) => {
    const { progressTracker: { desktop } } = themeTwo;

    return css`
      z-index: ${themeTwo.global.zIndex.low};
      height: ${desktop.stepHr.height || '2px'};
      width: ${desktop.stepSpacing || '8em'};
      bottom: ${desktop.stepHr.bottomPositioning || '2.5em'};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', desktop.stepHr.backgroundColor || 'black')}
    `;
  }}
`;

export const StepNumber = Styled.span`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 3em;
  text-align: center;

  ${({ theme: { themeTwo }}) => {
    const { progressTracker: { desktop } } = themeTwo;

    return css`
      z-index: ${themeTwo.global.zIndex.middle};
      width: ${desktop.stepNumber.size || '24px'};
      height: ${desktop.stepNumber.size || '24px'};
      line-height: ${desktop.stepNumber.font.lineHeight};
      /* border-radius */ ${cssDeclaration(themeTwo, 'border-radius', desktop.stepNumber.borderRadius || '50%')};
      /* box-shadow (gap between hr and circle) */
        ${cssDeclaration(themeTwo, 'box-shadow', { shadow: '0 0 0 3px', color: (desktop.backgroundColor || 'white')})};
      /* margin-bottom */ ${cssDeclaration(themeTwo, 'margin', { bottom: desktop.stepNumber.margin.bottom || '0.5em'})};

      /* reused styles */
      font-weight: ${desktop.stepNumber.font.weight};
      /* font-size */ ${cssDeclaration(themeTwo, 'font-size', desktop.stepNumber.font.size)};
      /* color */ ${cssDeclaration(themeTwo, 'color', desktop.stepNumber.font.color) || 'black'};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', desktop.stepNumber.backgroundColor || 'white')};
      /* border */ ${cssDeclaration(themeTwo, 'border', desktop.stepNumber.border || '1px solid black')};
    `;
  }}
`;

export const StepName = Styled.div`
  text-align: center;

  ${({ theme: { themeTwo }}) => {
    const { progressTracker: { desktop } } = themeTwo;

    return css`
      font-weight: ${desktop.stepName.font.weight};
      /* font-size */ ${cssDeclaration(themeTwo, 'font-size', desktop.stepName.font.size)};
      /* color */ ${cssDeclaration(themeTwo, 'color', desktop.stepName.color)};
    `;
  }}
`;

export const StepContainer = Styled.div<IStepContainerProps>`
  position: relative;
  text-align: center;
  display: inline-block;

  &:last-of-type ${StepHr} {
    display: none;
  }

  ${({ theme: { themeTwo }, isActive, isComplete }) => {
    const { progressTracker: { desktop } } = themeTwo;

    return css`
      width: ${desktop.stepSpacing || '7.5em'};

      ${isActive && css`
        ${StepNumber} {
          font-weight: ${desktop.state.active.stepNumber &&
            desktop.state.active.stepNumber.font &&
            desktop.state.active.stepNumber.font.weight};
          /* background-color */ ${desktop.state.active.stepNumber &&
            cssDeclaration(themeTwo, 'background-color', desktop.state.active.stepNumber.backgroundColor || 'primary')};
          /* border */ ${desktop.state.active.stepHr &&
            cssDeclaration(themeTwo, 'border', { color: desktop.state.active.stepHr.backgroundColor || 'primary'})};
          /* color */ ${desktop.state.active.stepNumber &&
            desktop.state.active.stepNumber.font &&
            cssDeclaration(themeTwo, 'color', desktop.state.active.stepNumber.font.color || 'white')};
          /* font-size */ ${desktop.state.active.stepNumber &&
            desktop.state.active.stepNumber.font &&
            cssDeclaration(themeTwo, 'font-size', desktop.state.active.stepNumber.font.size as VALID_GLOBAL_FONT_SIZES)};
        }

        ${StepName} {
          font-weight: ${desktop.stepName.font.weight};
          /* color */ ${desktop.state.active.stepName &&
            cssDeclaration(themeTwo, 'color', desktop.state.active.stepName.color || 'primary')};
          /* font-size */ ${desktop.state.active.stepName &&
            desktop.state.active.stepName.font &&
            cssDeclaration(themeTwo, 'font-size', desktop.state.active.stepName.font.size as VALID_GLOBAL_FONT_SIZES)};
        }
      `}

      ${isComplete && css`
        ${StepNumber} {
          font-weight: ${desktop.state.complete.stepNumber &&
            desktop.state.complete.stepNumber.font &&
            desktop.state.complete.stepNumber.font.weight};
          /* border */ ${cssDeclaration(themeTwo, 'border', { color: desktop.stepNumber.backgroundColor || 'primary'})};
          /* background-color */ ${desktop.state.complete.stepNumber &&
            cssDeclaration(themeTwo, 'background-color', desktop.state.complete.stepNumber.backgroundColor || 'primary')};
          /* color */ ${desktop.state.complete.stepNumber &&
            desktop.state.complete.stepNumber.font &&
            cssDeclaration(themeTwo, 'color', desktop.state.complete.stepNumber.font.color || 'white')};
          /* font-size */ ${desktop.state.complete.stepNumber &&
            desktop.state.complete.stepNumber.font &&
            cssDeclaration(themeTwo, 'font-size', desktop.state.complete.stepNumber.font.size as VALID_GLOBAL_FONT_SIZES)};
        }

        ${StepHr} {
          /* background-color */ ${desktop.state.complete.stepHr &&
            cssDeclaration(themeTwo, 'background-color', desktop.state.complete.stepHr.backgroundColor || 'primary')};
        }

        ${StepName} {
          font-weight: ${desktop.state.complete.stepName &&
            desktop.state.complete.stepName.font && desktop.state.complete.stepName.font.weight};
          /* color */ ${desktop.state.complete.stepName &&
            cssDeclaration(themeTwo, 'color', desktop.state.complete.stepName.color || 'primary')};
          /* font-size */ ${desktop.state.complete.stepName &&
            desktop.state.complete.stepName.font &&
            cssDeclaration(themeTwo, 'font-size', desktop.state.complete.stepName.font.size as VALID_GLOBAL_FONT_SIZES)};
        }
      `}
    `;
  }}
`;
